'use strict';

// Create Colido namespace if it hasn't been created yet
window.Colido = window.Colido || {};